import { createSlice } from '@reduxjs/toolkit';

const intailStateModal = {
  loading: {
    status: false,
  },
  alert: {
    status: false,
    msg: '',
    okStatus: 0,
    code: '',
  },
  getOtp: false,
  collection: {
    voucher: false,
    report: false,
    partyLedger: false,
    print: false,
    confirmSave: false,
    accountMaster: false,
    VoucherSummary: false,
    accountDetails: {
      accName: '',
      accAddress: '',
      accMobile: '',
      accNumber: '',
      stationId: '',
    },
    CurrentVoucherNo: '',
  },
  section_master: false,
  billing: {
    GuestCreate: false,
    editItemDetials: {},
    billSattalment: false,
    paymentMode: false,
    billHistry: false,
    confirmSaveBill: false,
    confirmPrintBill: false,
    shareBillImage: false,
    billingAccountMasterModal: false,
  },
  saleSummary: {
    viewBill: false,
  },
  modEmployeeMasterHelp: false,

  admin: {
    StationWiseIssueReport: false,
    UsersStatus: false,
    listStationMaster: false,
    locations: false,
    loginRequest: false,
  },
  masters: {
    expense: false,
    AccountMasterDataGrid: false,
    ItemMaster: false,
  },
  expense: {
    voucher: false,
    totalExpense: 0,
    paymode: 'CASH',
    voucherPrint: false,
  },

  isSessionExpired: false,
  isTodayIssue: false,

  checkEmailAlert: {
    status: false,
  },
  spinnerLoading: {
    status: false,
    text: 'loading',
  },

  checkVerifyEmailAlert: {
    status: false,
  },
  customeAlertMsg: {
    status: false,
    title: '',
    msg: '',
    buttonText: 'Ok',
  },
  loginApprovelModal: false,
  loginSucces: false,
  loginRejected: false,
  customeTwoButtonAlert: {
    status: false,
  },
  toast: {
    status: false,
    msg: '',
  },
  alertWithTitel: {
    status: false,
    title: '',
    msg: '',
    buttonText: 'Ok',
    lottie: '',
  },
  station_master: false,
  dayEndSummary: false,
  sectionMaster: false,
  sectionMasterHelp: false,
  departmentMasterHelp: false,
  departmentMaster: false,
  modPartyMasterHelp: false,
  modListStationMaster: false,
  partyRateMaster: false,
  numercKeyBoradStatus: false,
  quantityEdit: false,
  itemMasterHelp: false,
  numericKeyboardText: '',
  numericKeyBoardType: '',
  issueStockItem: '',
  saveType: '',
  modCompanyHelp: false,

  geniusKeyboard: false,
};

export const Modals = createSlice({
  name: 'modals',
  initialState: intailStateModal,
  reducers: {
    setloading(state, action) {
      state.loading.status = action.payload;
    },
    setModCompanyHelpStatus(state, action) {
      state.modCompanyHelp = action.payload;
    },
    setGeniusKeyModStatus(state, action) {
      state.geniusKeyboard = action.payload;
    },
    setStation_MasterStatus(state, action) {
      state.station_master = action.payload;
    },
    setSaveType(state, action) {
      state.saveType = action.payload;
    },
    setSection_MasterStatus(state, action) {
      state.section_master = action.payload;
    },
    setIssueStockItem(state, action) {
      state.issueStockItem = action.payload;
    },
    setModEmployeeMasterHelpStatus(state, action) {
      state.modEmployeeMasterHelp = action.payload;
    },
    setnumericKeyboardStatus(state, action) {
      state.numercKeyBoradStatus = action.payload;
    },
    setnumerickeyboardtext(state, action) {
      state.numericKeyboardText = action.payload;
    },
    setnumericKeyboardType(state, action) {
      state.numericKeyBoardType = action.payload;
    },

    setSpinnerLoading(state, action) {
      state.spinnerLoading.status = action.payload !== false ? true : false;
      state.spinnerLoading.text = action.payload;
    },
    setQuantityEditStatus(state, action) {
      state.quantityEdit = action.payload;
    },
    setModPartyMasterHelpStatus(state, action) {
      state.modPartyMasterHelp = action.payload;
    },
    setModListStationMasterStatus(state, action) {
      state.modListStationMaster = action.payload;
    },
    setSectionMasterStatus(state, action) {
      state.sectionMaster = action.payload;
    },

    setPartyRateMasterStatus(state, action) {
      state.partyRateMaster = action.payload;
    },
    setSectionMasterHelpStatus(state, action) {
      state.sectionMasterHelp = action.payload;
    },
    setDepartmentMasterHelpStatus(state, action) {
      state.departmentMasterHelp = action.payload;
    },
    setDepartmentMasterStatus(state, action) {
      state.departmentMaster = action.payload;
    },
    setItemMasterHelpStatus(state, action) {
      state.itemMasterHelp = action.payload;
    },
    setAlertWithTitle(state, action) {
      state.spinnerLoading.status = false;
      state.loading.status = false;
      state.alertWithTitel.title = action.payload.title;
      state.alertWithTitel.msg = action.payload.msg;
      state.alertWithTitel.status = true;
      state.alertWithTitel.lottie = action.payload.lottie;
    },
    setGetOtpModal(state, action) {
      state.getOtp = action.payload;
    },
    setItemMasterModalStatus(state, action) {
      state.masters.ItemMaster = action.payload;
    },
    setDayEndModalStatus(state, action) {
      state.dayEndSummary = action.payload;
    },
    setLoginRejected(state, action) {
      state.loginRejected = action.payload;
    },
    setLoginSuccess(state, action) {
      state.loginSucces = action.payload;
    },
    setLoginApprovelModalStatus(state, action) {
      state.loginApprovelModal = action.payload;
    },
    setLoginRequestsModalStatus(state, action) {
      state.admin.loginRequest = action.payload;
    },
    setLocationMarkers(state, action) {
      state.admin.locations = action.payload;
    },
    setExpVoucPrintModalStatus(state, action) {
      state.expense.voucherPrint = action.payload;
    },
    setExpensePaymode(state, action) {
      state.expense.paymode = action.payload;
    },
    setTotalExpense(state, action) {
      state.expense.totalExpense = action.payload;
    },
    setExpenseVoucherModalStatus(state, action) {
      state.expense.voucher = action.payload;
    },
    setListStationMasterModalStatus(state, action) {
      state.admin.listStationMaster = action.payload;
    },
    setExpenseMasterModalStatus(state, action) {
      state.masters.expense = action.payload;
    },
    setUserStatusModalStatus(state, action) {
      state.admin.UsersStatus = action.payload;
    },
    setVoucherSummaryModalStatus(state, action) {
      state.collection.VoucherSummary = action.payload;
    },
    setVoucherNumber(state, action) {
      state.collection.CurrentVoucherNo = action.payload;
    },
    setCollectionAccountDetails(state, action) {
      state.collection.accountDetails = action.payload;
    },
    setcollVoucherAccModStatus(state, action) {
      state.collection.accountMaster = action.payload;
    },
    setConfirmSaveVoucher(state, action) {
      state.collection.confirmSave = action.payload;
    },
    setCollectionVoucherPrintModalStatus(state, action) {
      state.collection.print = action.payload;
    },
    setPartyLedgerModalStatus(state, action) {
      state.collection.partyLedger = action.payload;
    },
    setVocherModalStatus(state, action) {
      state.collection.voucher = action.payload;
    },
    setCollectionReportModalStatus(state, action) {
      state.collection.report = action.payload;
    },
    setStationWiseIssueReportModalStatus(state, action) {
      state.admin.StationWiseIssueReport = action.payload;
    },
    setviewBillModalStatus(state, action) {
      state.saleSummary.viewBill = action.payload;
    },
    setBillingAccountMasterModalStatus(state, action) {
      state.billing.billingAccountMasterModal = action.payload;
    },
    setShareImageModalStatus(state, action) {
      state.billing.shareBillImage = action.payload;
    },
    setConfirmPrintBillModalStatus(state, action) {
      state.billing.confirmPrintBill = action.payload;
    },
    setConfirmSaveBillstatus(state, action) {
      state.billing.confirmSaveBill = action.payload;
    },
    setAccountMasterDAtagridStatus(state, action) {
      state.masters.AccountMasterDataGrid = action.payload;
    },
    setGuestMasterModalStatus(state, action) {
      state.masters.guestMaster = action.payload;
    },
    setPaymentMode(state, action) {
      state.billing.paymentMode = action.payload;
    },
    setCreateGuestMasterModalStatus(state, action) {
      state.masters.createGuestMaster = action.payload;
    },
    setBillHistryModalStatus(state, action) {
      state.billing.billHistry = action.payload;
    },
    setToast(state, action) {
      state.toast = action.payload;
      // state.toast.status = action.payload.status;
      // state.toast.msg = action.payload.msg;
    },

    setCustomeAlertButtonText(state, action) {
      state.customeAlertMsg.buttonText = action.payload;
    },
    setAlertwithTitleModalStatus(state, action) {
      state.loading.status = false;
      state.alertWithTitel.status = action.payload ? action.payload : false;
    },
    setCheckEmailAlert(state, action) {
      state.checkEmailAlert.status = action.payload;
    },
    setCheckVerifyEmailAlert(state, action) {
      state.checkVerifyEmailAlert.status = action.payload;
    },
    setALertStatus(state, action) {
      state.alert.status = action.payload;
    },
    setCustomeAlertStatus(state, action) {
      state.customeAlertMsg.status = action.payload;
    },
    setAlertMsg(state, action) {
      state.alert.msg = action.payload;
    },
    setCustomeAlertMsg(state, action) {
      state.customeAlertMsg.msg = action.payload;
    },
    setCustomeAlertTitle(state, action) {
      state.customeAlertMsg.title = action.payload;
    },

    setSessionExpired(state, action) {
      state.isSessionExpired = action.payload;
    },
    setNoIssueAlert(state, action) {
      state.isTodayIssue = action.payload;
    },
    setEditItemDetails(state, action) {
      state.billing.editItemDetials = action.payload;
    },
    setAlertOkStatus(state, action) {
      state.alert.okStatus = action.payload;
    },
    setCustomeTwoButtomAlert(state, action) {
      state.customeTwoButtonAlert.status = action.payload;
    },
    setBillSattalmentModalStatus(state, action) {
      state.billing.billSattalment = action.payload;
    },
    setGuestCreateModalStatus(state, action) {
      state.billing.GuestCreate = action.payload;
    },
    resetModalReduxState(state, action) {
      state = intailStateModal;
    },
  },
});

export default Modals.reducer;

export const {
  setCustomeAlertButtonText,
  setDayEndModalStatus,
  setAlertWithTitle,
  setIssueStockItem,
  setNoIssueAlert,
  setSectionMasterStatus,
  ithTitleModalStatus,
  setSectionMasterHelpStatus,
  setGetOtpModal,
  setAlertwithTitleModalStatus,
  setnumericKeyboardStatus,
  setItemMasterModalStatus,
  setExpensePaymode,
  setLoginApprovelModalStatus,
  setModCompanyHelpStatus,
  setExpVoucPrintModalStatus,
  setSpinnerLoading,
  setSessionExpired,
  setSection_MasterStatus,
  setStation_MasterStatus,
  setModEmployeeMasterHelpStatus,
  setSaveType,
  setGeniusKeyModStatus,
  setnumerickeyboardtext,
  setQuantityEditStatus,
  setnumericKeyboardType,
  setDepartmentMasterHelpStatus,
  setModListStationMasterStatus,
  setTotalExpense,
  setDepartmentMasterStatus,
  setLocationMarkers,
  setPartyRateMasterStatus,
  setModPartyMasterHelpStatus,
  setExpenseVoucherModalStatus,
  setListStationMasterModalStatus,
  setExpenseMasterModalStatus,
  setUserStatusModalStatus,
  setVoucherSummaryModalStatus,
  setVoucherNumber,
  setItemMasterHelpStatus,
  setCollectionAccountDetails,
  setcollVoucherAccModStatus,
  setConfirmSaveVoucher,
  setCollectionVoucherPrintModalStatus,
  setCollectionReportModalStatus,
  setPartyLedgerModalStatus,
  setVocherModalStatus,
  setStationWiseIssueReportModalStatus,
  setBillingAccountMasterModalStatus,
  setConfirmPrintBillModalStatus,
  setGuestCreateModalStatus,
  setBillSattalmentModalStatus,
  setCustomeTwoButtomAlert,
  setConfirmSaveBillstatus,
  setGuestMasterModalStatus,
  setCreateGuestMasterModalStatus,
  setloading,
  setLoginSuccess,
  setviewBillModalStatus,
  setAccountMasterDAtagridStatus,
  setEditItemDetails,
  setALertStatus,
  setAlertMsg,
  setPaymentMode,
  setLoginRejected,
  setAlertOkStatus,
  setShareImageModalStatus,
  setCheckEmailAlert,
  setBillHistryModalStatus,
  setCheckVerifyEmailAlert,
  setCustomeAlertMsg,
  setCustomeAlertStatus,
  setCustomeAlertTitle,
  setItemGroupMasterModalStatus,
  setCreateItemGroupModalStatus,
  setToast,
  setLoginRequestsModalStatus,
  resetModalReduxState,
} = Modals.actions;

export const selectStatus = (state) => state.modals.loading.status;

export const selectCheckEmailStatus = (state) =>
  state.modals.checkEmailAlert.status;
export const SelectStation_MasterStatus = (state) =>
  state.modals.station_master;

export const selectCheckVerifyEmailStatus = (state) =>
  state.modals.checkVerifyEmailAlert.status;
export const SelectAlertStatus = (state) => state.modals.alert.status;
export const selectAlertMsg = (state) => state.modals.alert.msg;
export const selectSavetype = (state) => state.modals.saveType;
export const selectAlertOkStatus = (state) => state.modals.alert.okStatus;
export const SelectModListStationMasterStatus = (state) =>
  state.modals.modListStationMaster;
export const SelectQuantityEditStatus = (state) => state.modals.quantityEdit;
export const SelectModEmployeeMasterHelpStatus = (state) =>
  state.modals.modEmployeeMasterHelp;
export const selectCustomeAlertTitle = (state) =>
  state.modals.customeAlertMsg.title;
export const selectCustomeAlertStatus = (state) =>
  state.modals.customeAlertMsg.status;
export const selectCustomeAlertMsg = (state) =>
  state.modals.customeAlertMsg.msg;
export const selectCustomeAlertButton = (state) =>
  state.modals.customeAlertMsg.buttonText;
export const selectCustomeTwoButtomAlert = (state) =>
  state.modals.customeTwoButtonAlert.status;
export const SelectSection_MasterStatus = (state) =>
  state.modals.section_master;
/// work new from here
export const SelectPartyRateMasterStatus = (state) =>
  state.modals.partyRateMaster;
export const selectModCompanyHelpStatus = (state) =>
  state.modals.modCompanyHelp;
export const SelectToastStatus = (state) => state.modals.toast.status;

export const SelectToastMsg = (state) => state.modals.toast.msg;
export const SelectIsExpired = (state) => state.modals.isSessionExpired;
export const SelectNoIssueStatus = (state) => state.modals.isTodayIssue;

export const SelectGuestCreateStatus = (state) =>
  state.modals.billing.GuestCreate;
export const SelectEditItemDetails = (state) =>
  state.modals.billing.editItemDetials;
export const SelectBillSettlement = (state) =>
  state.modals.billing.billSattalment;
export const SelectCreateGuestMasterModalStatus = (state) =>
  state.modals.masters.createGuestMaster;
export const SelectGuestMasterModalStatus = (state) =>
  state.modals.masters.guestMaster;
export const SelectPaymentModeStatus = (state) =>
  state.modals.billing.paymentMode;

export const selectBillHistryModalStatues = (state) =>
  state.modals.billing.billHistry;
export const SelectModPartyMasterHelpStatus = (state) =>
  state.modals.modPartyMasterHelp;

export const selectAccountMAsterDataGridStatus = (state) =>
  state.modals.masters.AccountMasterDataGrid;
export const slectConfirmSaveBillStatus = (state) =>
  state.modals.billing.confirmSaveBill;
export const selectPrintModalStatus = (state) =>
  state.modals.billing.confirmPrintBill;

export const selectShareImageModalStatus = (state) =>
  state.modals.billing.shareBillImage;
export const selectBillingAccountMasterModalStatus = (state) =>
  state.modals.billing.billingAccountMasterModal;

export const selectSaleviewBillModalStatus = (state) =>
  state.modals.saleSummary.viewBill;
export const selectAdminStationWiseIssueModalsStatus = (state) =>
  state.modals.admin.StationWiseIssueReport;

// collection
export const selectCollectionVoucherModalStatus = (state) =>
  state.modals.collection.voucher;

export const selectCollectionReportModalStatus = (state) =>
  state.modals.collection.report;
export const selectpartyLedgerModalstatus = (state) =>
  state.modals.collection.partyLedger;
export const selectCollectionVocuherPrintStatus = (state) =>
  state.modals.collection.print;
export const selectConfrimSaveVoucher = (state) =>
  state.modals.collection.confirmSave;
export const selectVoucherAccountModalStatus = (state) =>
  state.modals.collection.accountMaster;
export const selectCollectionAccountDetails = (state) =>
  state.modals.collection.accountDetails;
export const selectVoucherNumber = (state) =>
  state.modals.collection.CurrentVoucherNo;
export const selectCollectionVocuherModalStatus = (state) =>
  state.modals.collection.VoucherSummary;

// admin user status

export const selectUserStatusModalStatus = (state) =>
  state.modals.admin.UsersStatus;

// expense master

export const selectExpensemasterModalStatus = (state) =>
  state.modals.masters.expense;
export const selectListStationMasterModalStatus = (state) =>
  state.modals.admin.listStationMaster;
export const selectExpenseVoucherModalStatus = (state) =>
  state.modals.expense.voucher;
export const selectTotalExpense = (state) => state.modals.expense.totalExpense;
export const selectExpensePaymode = (state) => state.modals.expense.paymode;
export const selectExpVoucPrintModalStatus = (state) =>
  state.modals.expense.voucherPrint;

//admin

export const selectLocationsMarkerModalStatus = (state) =>
  state.modals.admin.locations;
export const selectLoginRequestModatStatus = (state) =>
  state.modals.admin.loginRequest;
export const selectLoginApprovelModalStatus = (state) =>
  state.modals.loginApprovelModal;

export const selectLoginSuccesModalSuccess = (state) =>
  state.modals.loginSucces;
export const selectLoginRejectedModalStatus = (state) =>
  state.modals.loginRejected;
export const selectDayEndSummaryModalStatus = (state) =>
  state.modals.dayEndSummary;

export const selectItemMasterModalStatus = (state) =>
  state.modals.masters.ItemMaster;
export const selectGetOtpModal = (state) => state.modals.getOtp;
export const selectAlertWithTitleDetails = (state) =>
  state.modals.alertWithTitel;
export const selectAlertWithTitleModalStatus = (state) =>
  state.modals.alertWithTitel.status;
export const SelectSectionMasterHelpStatus = (state) =>
  state.modals.sectionMasterHelp;
export const SelectSectionMasterStatus = (state) => state.modals.sectionMaster;
export const SelectDepartmentMasterHelpStatus = (state) =>
  state.modals.departmentMasterHelp;
export const SelectDepartmentMasterStatus = (state) =>
  state.modals.departmentMaster;
export const SelectItemMasterHelpStatus = (state) =>
  state.modals.itemMasterHelp;
export const selectSpinnerLoading = (state) =>
  state.modals.spinnerLoading.status;
export const selectSpinnerText = (state) => state.modals.spinnerLoading.text;

export const selectNumerickeyboardStatus = (state) =>
  state.modals.numercKeyBoradStatus;
export const selectNumerickeyboardtext = (state) =>
  state.modals.numericKeyboardText;
export const selectNumerickeyboardType = (state) =>
  state.modals.numericKeyBoardType;
export const selectIssueItem = (state) => state.modals.issueStockItem;
export const selectGeniusKeyboardStaus = (state) => state.modals.geniusKeyboard;
